<template>
  <div class="inner">
    <h5 class="mt-3 font-weight-bold">เกรด</h5>
    <div
      v-for="_globalCriteria in exam._globalCriteria"
      :key="_globalCriteria.index"
      class="grading-bg"
    >
      <ul>
        <li
          id="abc"
          class="button-grading"
        >
          <div
            class="text-left font-weight-bold ml-2"
          >
            {{ _globalCriteria.grade }} |
            {{ _globalCriteria.lowerBoundRange }} -
            {{ _globalCriteria.upperBoundRange }} เปอร์เซ็นต์
          </div>
        </li>
      </ul>
    </div>

    <SectionCriteria 
      v-if="comId == 473"
      :value="hasSectionCriteria"
      :disabled="true"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SectionCriteria from "@/components/shared/SectionCriteria.vue";
export default {
  components: {
    SectionCriteria,
  },
  props: {
    gradeTitle: String,
    lowerRange: Number,
    upperRange: Number,
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      token: localStorage.getItem("token"),
      nextGrade: null,
      addStatusMessage: false,
      ModalPreviewChoices: false,
      titleModal: "",
      globalCriteria: [],
      previewMessage: "",
    };
  },
  computed: {
    ...mapGetters("ExamBuilder", ["exam"]),
    hasSectionCriteria() {
      return this.exam?._options?.sectionCriteria ?? false
    }
  },
};
</script>

<style scoped>
.grading-bg {
  background-color: #f0f0f0;
  list-style: none;
  padding: 15px 15px;
  border-radius: 10px;
  margin: 10px 0;
  /* min-height: 100vh; */
}
</style>
